// Funções de apoio compartilhadas pelas telas do ponto.

export const DIAS_SEMANA = [
  { campo: "minutosSegunda", rotulo: "Segunda" },
  { campo: "minutosTerca", rotulo: "Terça" },
  { campo: "minutosQuarta", rotulo: "Quarta" },
  { campo: "minutosQuinta", rotulo: "Quinta" },
  { campo: "minutosSexta", rotulo: "Sexta" },
  { campo: "minutosSabado", rotulo: "Sábado" },
  { campo: "minutosDomingo", rotulo: "Domingo" },
];

const doisDigitos = (valor) => String(valor).padStart(2, "0");

// "2026-11" do mês atual, no horário local.
export const competenciaAtual = () => {
  const hoje = new Date();
  return `${hoje.getFullYear()}-${doisDigitos(hoje.getMonth() + 1)}`;
};

export const deslocarCompetencia = (competencia, meses) => {
  const [ano, mes] = competencia.split("-").map(Number);
  const data = new Date(ano, mes - 1 + meses, 1);
  return `${data.getFullYear()}-${doisDigitos(data.getMonth() + 1)}`;
};

export const nomeCompetencia = (competencia) => {
  const [ano, mes] = competencia.split("-").map(Number);
  const nome = new Date(ano, mes - 1, 1).toLocaleDateString("pt-BR", {
    month: "long",
  });
  return `${nome.charAt(0).toUpperCase()}${nome.slice(1)}/${ano}`;
};

// "2026-11-03" -> "03/11"
export const dataCurta = (dataIso) => {
  if (!dataIso) return "";
  const [, mes, dia] = dataIso.split("-");
  return `${dia}/${mes}`;
};

// "2026-11-03" -> "03/11/2026"
export const dataCompleta = (dataIso) => {
  if (!dataIso) return "";
  const [ano, mes, dia] = dataIso.split("-");
  return `${dia}/${mes}/${ano}`;
};

export const hojeIso = () => {
  const hoje = new Date();
  return `${hoje.getFullYear()}-${doisDigitos(hoje.getMonth() + 1)}-${doisDigitos(hoje.getDate())}`;
};

// 480 -> "08:00"
export const minutosParaHora = (minutos) => {
  const valor = Number(minutos) || 0;
  return `${doisDigitos(Math.floor(valor / 60))}:${doisDigitos(valor % 60)}`;
};

// "08:30" -> 510. Vazio vira 0. Retorna null se inválido.
export const horaParaMinutos = (texto) => {
  if (!texto) return 0;
  const correspondencia = /^(\d{1,2}):(\d{2})$/.exec(texto.trim());
  if (!correspondencia) return null;
  const horas = Number(correspondencia[1]);
  const minutos = Number(correspondencia[2]);
  if (minutos > 59 || horas * 60 + minutos > 24 * 60) return null;
  return horas * 60 + minutos;
};

// Completa a lista de marcações com vazios até as 4 colunas do cartão.
export const quatroColunas = (marcacoes = []) =>
  [0, 1, 2, 3].map((indice) => marcacoes[indice] || "");

export const baixarArquivo = (blob, nomeArquivo) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = nomeArquivo;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

// Abre o PDF numa nova aba para imprimir. Se o navegador bloquear, baixa o arquivo.
export const abrirParaImprimir = (blob, nomeArquivo) => {
  const url = URL.createObjectURL(blob);
  const janela = window.open(url, "_blank");
  if (!janela) {
    baixarArquivo(blob, nomeArquivo);
    return false;
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
  return true;
};
